<template>
  <div class="main-content-container">
    <div class="container">
      <!-- Page Header -->
      <div class="page-header row no-gutters py-4">
        <div class="col-6 text-center text-sm-left mb-0">
          <span class="text-uppercase page-subtitle">sessão</span>
          <h3 class="page-title">Dashboard de Chargeback</h3>
        </div>
        <div class="col-6 d-flex" v-if="!loading">
          <div class="input-group d-flex justify-content-end my-auto">
            <button
              type="button"
              class="btn btn-primary btn-sm mt-3"
              @click="OpenModalFilter()"
            >
              <i class="fas fa-filter"></i>
              {{ countFilter > 0 ? "Filtros aplicados" : "" }}
              <span v-if="countFilter > 0" class="badge badge-light">{{
                countFilter
              }}</span>
            </button>
            <button
              v-if="countFilter > 0"
              type="button"
              class="input-group-text btn-sm ml-1 mt-3"
              v-b-tooltip.hover.bottom
              title="Limpar filtros"
              @click="ResetFilter()"
            >
              <i class="fas fa-eraser"></i>
            </button>
          </div>
        </div>
      </div>
      <d-row>
        <!-- Cards -->
        <d-col
          v-for="(card, index) in Cards"
          :key="index"
          md="6"
          lg="4"
          class="mb-4"
        >
          <cards
            :id="`card-${index}`"
            :link="card.link"
            :label="card.label"
            :value="card.value"
          />
        </d-col>
      </d-row>

      <d-row>
        <d-col
          class="mb-12 col-lg-12 lg-s"
          v-if="
            !loading &&
            this.infoDashboard.ChargebackDashboardBrand != null &&
            this.infoDashboard.ChargebackDashboardBrand.length > 0
          "
        >
          <d-card class="card-small go-stats">
            <!-- Card Header -->
            <d-card-header class="border-bottom">
              <h6 class="m-0" style="font-weight: 600">
                Bandeira<span style="float: right; margin-right: 10px"
                  >Percentual (%)</span
                >
              </h6>
            </d-card-header>
            <d-card-body
              v-for="(service, index) in this.infoDashboard
                .ChargebackDashboardBrand"
              :key="index"
              class="py-0"
            >
              <!-- Services List Group -->
              <d-list-group flush class="list-group-small list-group-flush">
                <d-list-group-item
                  class="d-flex row px-0"
                  v-if="service.PercentageFraudAmount > 0"
                >
                  <d-col lg="2" md="2" sm="2">
                    <center>
                      <i :class="GetDataImage(service.Brand.Id)"></i>
                    </center>
                  </d-col>
                  <d-col lg="6" md="6" sm="6">
                    <h6 class="go-stats__label mb-1">
                      {{ service.Brand.Name }}
                    </h6>
                    <div class="go-stats__meta">
                      <span class="mr-2">
                        <strong>{{ service.QtChargeback | number }}</strong>
                        transações geradas.

                        <strong
                          ><br />Valor movimentado de
                          <strong class="text-success">{{
                            service.AmountChargeback | currency
                          }}</strong
                          >.</strong
                        >
                      </span>
                    </div>
                  </d-col>
                  <d-col lg="4" md="4" sm="4" class="d-flex">
                    <div class="go-stats__value text-right ml-auto">
                      <h6 class="go-stats__label mb-1">
                        {{ service.PercentageFraudAmount | percentage }}
                      </h6>

                      <button
                        class="btn button-arrow"
                        type="button"
                        v-b-tooltip.hover.bottom
                        title="Clique aqui para detalhar"
                        v-on:click="
                          OpenBrandTransaction($event, service.Brand.Id)
                        "
                      >
                        <span class="go-stats__meta">Detalhar</span>
                        <i class="fas fa-angle-right"></i>
                      </button>
                    </div>
                  </d-col>
                </d-list-group-item>
              </d-list-group>
            </d-card-body>
            <d-card-footer class="border-top">
              <d-row>
                <!-- Footer -->
                <d-col class="text-right view-report"> </d-col>
              </d-row>
            </d-card-footer>
          </d-card>
        </d-col>
      </d-row>
      <br />
      <div v-if="loading">
        <loader :is-loading="loading" />
      </div>
      <div class="row equal-cols" v-else>
        <d-col class="mb-12 col-lg-12 lg-s" v-if="showChart">
          <d-row>
            <d-col class="mb-6 col-lg-6 lg-s">
              <chart-card
                type="line"
                :title="'Chargeback Diário'"
                :chartData="chartChargeback"
              ></chart-card>
            </d-col>
            <d-col class="mb-6 col-lg-6 lg-s">
              <chart-card
                type="line"
                :title="'Chargeback Diário'"
                :chartData="chartChargebackPercentage"
              ></chart-card>
            </d-col>
          </d-row>
          <br />
        </d-col>

        <d-col class="mb-12 col-lg-12 lg-s" v-if="showChartBrand">
          <d-row>
            <d-col class="mb-12 col-lg-12 lg-s">
              <chart-card
                type="line"
                title="Chargeback por bandeira"
                :chartData="chartChargebackBrand"
              ></chart-card>
            </d-col>
          </d-row>
          <br />
        </d-col>

        <d-col class="mb-12 col-lg-12 lg-s" v-if="showChartMcc">
          <d-row>
            <d-col class="mb-12 col-lg-12 lg-s">
              <chart-card
                type="line"
                title="Chargeback por MCC"
                :chartData="chartChargebackMCC"
              ></chart-card>
            </d-col>
          </d-row>
          <br />
        </d-col>
      </div>
    </div>
    <a
      href="#"
      class="btn-float btn-primary"
      v-show="showBtnScroll"
      v-on:click="ScrollToTop($event)"
    >
      <i class="fa fa-chevron-up"></i>
    </a>

    <b-modal
      id="mFilter"
      title="Filtros"
      centered
      :no-close-on-backdrop="true"
      :no-close-on-esc="false"
    >
      <d-form-row>
        <d-col md="12" class="form-group">
          <d-select v-model="isMonthly">
            <option :value="1" selected>Mensal</option>
            <option :value="0">Anual</option>
          </d-select>
        </d-col>
        <d-col md="6" class="form-group">
          <date-field
            v-model="filter.paymentDate"
            format="MMMM yyyy"
            minimumView="month"
            v-if="isMonthly == 1"
          ></date-field>
        </d-col>
        <d-col md="6" class="form-group">
          <d-select v-model="filter.idMcc" :value="null" v-if="isMonthly == 1">
            <option :value="null" selected>Selecione o MCC</option>
            <option
              v-for="mcc in mccs"
              v-bind:key="mcc.EstablishmentID"
              v-bind:value="mcc.Id"
            >
              <span v-if="mcc.EstablishmentID != null">
                {{ mcc.Name }} - ({{ mcc.EstablishmentID }})
              </span>
              <span v-else>
                {{ mcc.Name }}
              </span>
            </option>
          </d-select>
        </d-col>
        <d-col md="12" class="form-group">
          <date-field
            v-model="filter.paymentYear"
            format="yyyy"
            minimumView="year"
            v-if="isMonthly == 0"
          ></date-field>
        </d-col>
      </d-form-row>
      <template slot="modal-footer">
        <b-button
          variant="primary"
          class="btn btn-primary"
          v-b-tooltip.hover.bottom
          title="Pesquisar"
          @click="Filter()"
        >
          <i class="fas fa-search"></i>
        </b-button>
        <b-button
          variant="primary"
          class="input-group-text"
          v-b-tooltip.hover.bottom
          title="Limpar filtros"
          @click="ResetFilter()"
        >
          <i class="fas fa-eraser"></i>
        </b-button>
      </template>
    </b-modal>
  </div>
</template>


<script>
import { hasValue } from "../../utils/functions.js";
import cards from "@/components/common/cards";
import chartCard from "@/components/common/chart-card";
import dateField from "../common/date-field";

export default {
  name: "chargeback-dashboard",
  components: {
    cards,
    chartCard,
    dateField,
  },
  data: function () {
    return {
      isMonthly: 1,
      loading: false,
      showChart: false,
      showChartBrand: false,
      showChartMcc: false,
      countFilter: 0,
      filter: {
        idMcc: null,
        paymentYear: this.$options.filters.date(new Date(), "YYYY-MM-DD"),
        paymentDate: this.$options.filters.date(new Date(), "YYYY-MM-DD"),
      },
      mccs: [],
      infoDashboard: {
        AmountChargeback: 0,
        AmountChargebackDispute: 0,
        AmountChargebackEffective: 0,
        AmountChargebackPaid: 0,
      },
      chartChargeback: {
        labels: [],
        datasets: [],
      },
      chartChargebackPercentage: {
        labels: [],
        datasets: [],
      },
      chartChargebackBrand: {
        labels: [],
        datasets: [],
      },
      chartChargebackMCC: {
        labels: [],
        datasets: [],
      },
      showBtnScroll: false,
    };
  },
  created() {
    window.addEventListener("scroll", this.HandleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.HandleScroll);
  },
  computed: {
    Cards() {
      return [
        {
          label: "Valor transacionado",
          value: this.$options.filters.currency(
            this.infoDashboard.AmountChargeback
          ),
          smallFontSizeValue: true,
          lg: 4,
        },
        {
          label: "Valor transacionado em disputa",
          value: this.$options.filters.currency(
            this.infoDashboard.AmountChargebackDispute
          ),
          smallFontSizeValue: true,
          lg: 4,
        },
        {
          label: "Valor transacionado de chargeback",
          value: this.$options.filters.currency(
            this.infoDashboard.AmountChargebackEffective
          ),
          smallFontSizeValue: true,
          lg: 4,
        },
        {
          label: "Valor repassado",
          value: this.$options.filters.currency(
            this.infoDashboard.AmountChargebackPaid
          ),
          smallFontSizeValue: true,
          lg: 4,
        },
        {
          label: "Percentual total",
          value: this.$options.filters.percentage(
            this.infoDashboard.PercentageFraudAmount
          ),
          smallFontSizeValue: true,
          lg: 4,
        },
        {
          label: "Quantidade de chargeback",
          value: this.$options.filters.number(
            this.infoDashboard.CountChargeback
          ),
          smallFontSizeValue: true,
          lg: 4,
        },
      ];
    },
  },
  watch: {},
  mounted() {
    this.ListMCC();
    this.GetDashboard();
    this.$root.$on("bv::tooltip::show", (bvEvent) => {
      if (bvEvent.target.offsetWidth == bvEvent.target.scrollWidth)
        bvEvent.preventDefault();
    });
  },
  methods: {
    OpenModalFilter: function () {
      this.$bvModal.show("mFilter");
    },
    Filter: function () {
      this.$bvModal.hide("mFilter");
      this.GetDashboard();
    },
    ResetFilter: function () {
      this.filter = {
        paymentDate: this.$options.filters.date(new Date(), "YYYY-MM-DD"),
        idMcc: null,
        paymentYear: null,
      };
      this.GetDashboard();
    },
    GetDataBorderColor: function (brand) {
      switch (brand) {
        case 1:
          return "rgba(0, 48, 77, 0.8)";
        case 2:
          return "rgba(90, 97, 105, 0.8)";
        case 3:
          return "rgba(10, 195, 127, 0.8)";
        case 4:
          return "rgba(81, 195, 100, 0.8)";
        case 5:
          return "rgba(203, 205, 61, 0.8)";
        case 6:
          return "rgba(0, 184, 216, 0.8)";
        case 7:
          return "rgba(255, 180, 0, 0.8)";
        case 8:
          return "rgba(150, 92, 174, 0.8)";
        case 9:
          return "rgba(234, 35, 77, 0.8)";
        case 10:
          return "rgba(33, 37, 41, 0.8)";
        case 11:
          return "rgba(255, 65, 105, 0.8)";
        case 12:
          return "rgba(103, 78, 236, 0.8)";
        case 13:
          return "rgba(26, 219, 162, 0.8)";
      }
    },
    GetDataColor: function (brand) {
      switch (brand) {
        case 1:
          return "rgba(0, 48, 77, 0.2)";
        case 2:
          return "rgba(90, 97, 105, 0.2)";
        case 3:
          return "rgba(10, 195, 127, 0.2)";
        case 4:
          return "rgba(81, 195, 100, 0.2)";
        case 5:
          return "rgba(203, 205, 61, 0.2)";
        case 6:
          return "rgba(0, 184, 216, 0.2)";
        case 7:
          return "rgba(255, 180, 0, 0.2)";
        case 8:
          return "rgba(150, 92, 174, 0.2)";
        case 9:
          return "rgba(234, 35, 77, 0.2)";
        case 10:
          return "rgba(33, 37, 41, 0.2)";
        case 11:
          return "rgba(255, 65, 105, 0.2)";
        case 12:
          return "rgba(103, 78, 236, 0.2)";
        case 13:
          return "rgba(26, 219, 162, 0.2)";
      }
    },
    GetDataMccBorderColor: function (mcc) {
      switch (mcc) {
        case 187:
          return "rgba(0, 48, 77, 0.8)";
        case 280:
          return "rgba(90, 97, 105, 0.8)";
        case 281:
          return "rgba(118, 195, 10, 0.8)";
        case 291:
          return "rgba(81, 195, 100, 0.8)";
        case 524:
          return "rgba(203, 205, 61, 0.8)";
        case 595:
          return "rgba(0, 184, 216, 0.8)";
        case 819:
          return "rgba(255, 180, 0, 0.8)";
        case 866:
          return "rgba(150, 92, 174, 0.8)";
        case 881:
          return "rgba(234, 35, 77, 0.8)";
        case 887:
          return "rgba(33, 37, 41, 0.8)";
        case 891:
          return "rgba(255, 65, 105, 0.8)";
        case 904:
          return "rgba(237, 119, 176, 0.8)";
        case 989:
          return "rgba(26, 219, 162, 0.8)";
        case 1000:
          return "rgba(141, 252, 197, 0.8)";
        case 1032:
          return "rgba(242, 160, 78, 0.8)";
        case 1068:
          return "rgba(242, 78, 242, 0.8)";
        case 1073:
          return "rgba(78, 160, 242, 0.8)";
        case 1097:
          return "rgba(78, 78, 242, 0.8)";
        case 1195:
          return "rgba(242, 242, 78, 0.8)";
        case 1273:
          return "rgba(150, 157, 10, 0.8)";
        case 1289:
          return "rgba(248, 98, 165, 0.8)";
        case 1315:
          return "rgba(180, 98, 248, 0.8)";
        case 1318:
          return "rgba(51, 45, 49, 0.8)";
        case 1335:
          return "rgba(83, 88, 3, 0.8)";
      }
    },
    GetDataMccColor: function (mcc) {
      switch (mcc) {
        case 187:
          return "rgba(0, 48, 77, 0.2)";
        case 280:
          return "rgba(90, 97, 105, 0.2)";
        case 281:
          return "rgba(118, 195, 10, 0.2)";
        case 291:
          return "rgba(81, 195, 100, 0.2)";
        case 524:
          return "rgba(203, 205, 61, 0.2)";
        case 595:
          return "rgba(0, 184, 216, 0.2)";
        case 819:
          return "rgba(255, 180, 0, 0.2)";
        case 866:
          return "rgba(150, 92, 174, 0.2)";
        case 881:
          return "rgba(234, 35, 77, 0.2)";
        case 887:
          return "rgba(33, 37, 41, 0.2)";
        case 891:
          return "rgba(255, 65, 105, 0.2)";
        case 904:
          return "rgba(237, 119, 176, 0.2)";
        case 989:
          return "rgba(26, 219, 162, 0.2)";
        case 1000:
          return "rgba(141, 252, 197, 0.2)";
        case 1032:
          return "rgba(242, 160, 78, 0.2)";
        case 1068:
          return "rgba(242, 78, 242, 0.2)";
        case 1073:
          return "rgba(78, 160, 242, 0.2)";
        case 1097:
          return "rgba(78, 78, 242, 0.2)";
        case 1195:
          return "rgba(242, 242, 78, 0.2)";
        case 1273:
          return "rgba(150, 157, 10, 0.2)";
        case 1289:
          return "rgba(248, 98, 165, 0.2)";
        case 1315:
          return "rgba(180, 98, 248, 0.2)";
        case 1318:
          return "rgba(51, 45, 49, 0.2)";
        case 1335:
          return "rgba(83, 88, 3, 0.2)";
      }
    },
    GetDataImage: function (brand) {
      switch (brand) {
        case 1:
          return "fab fa-cc-visa iconList";
        case 2:
          return "fab fa-cc-mastercard iconList";
        case 3:
        case 6:
          return "fab fa-cc-amex iconList";
        case 9:
          return "fab fa-cc-jcb iconList";
        case 10:
          return "fab fa-cc-diners iconList";
        case 11:
          return "fab fa-cc-discover iconList";
        default:
          return "far fa-credit-card iconList";
      }
    },
    GetDashboard: function () {
      this.countFilter = 0;
      if (hasValue(this.filter.paymentDate) && this.isMonthly == 1)
        this.countFilter++;
      if (hasValue(this.filter.idMcc) && this.isMonthly == 1)
        this.countFilter++;
      if (hasValue(this.filter.paymentYear) && this.isMonthly == 0)
        this.countFilter++;

      this.loading = true;
      let data = {
        ...{
          "Object.ReferenceDate":
            this.isMonthly == 1 ? this.filter.paymentDate : null,
          "Object.IdMCC": this.isMonthly == 1 ? this.filter.idMcc : null,
          "Object.ReferenceYear":
            this.isMonthly == 0 ? this.filter.paymentYear : null,
        },
      };
      this.$store
        .dispatch("GetDashboard", { params: data })
        .then((response) => {
          // #region Chart Chargeback Diário: Quantidade
          this.infoDashboard = response;
          this.chartChargeback = {
            labels: [],
            datasets: [],
          };

          let label = "Quantidade";
          let borderColor = "rgba(26, 45, 91, 0.8)";
          let backgroundColor = "rgba(0, 101, 179, 0.3)";

          let dataset = {
            label: label,
            borderColor: borderColor,
            backgroundColor: backgroundColor,
            data: [],
          };

          var i = 0;
          if (
            this.infoDashboard.ChargebackDashboardDays != null &&
            this.infoDashboard.ChargebackDashboardDays.length > 0
          ) {
            this.showChart = true;

            // #region Char Chargeback Diário: Quantidade
            this.infoDashboard.ChargebackDashboardDays.forEach((element) => {
              this.chartChargeback.labels.push(
                this.$options.filters.date(element.ChargebackDate, "DD")
              );

              dataset.data.push({
                x: i,
                y: element.CountChargeback,
              });

              i = i + 1;
            });

            this.chartChargeback.datasets.push(dataset);

            // #endregion Chart Chargeback Diário: Quantidade
            // #region Chart Chargeback Diário: Percentual

            this.chartChargebackPercentage = {
              labels: [],
              datasets: [],
            };
            var i = 0;
            label = "Percentual";
            borderColor = "rgba(26, 45, 91, 0.8)";
            backgroundColor = "rgba(0, 101, 179, 0.3)";

            dataset = {
              label: label,
              borderColor: borderColor,
              backgroundColor: backgroundColor,
              data: [],
            };

            this.infoDashboard.ChargebackDashboardDayPercentage.forEach(
              (element) => {
                this.chartChargebackPercentage.labels.push(
                  this.$options.filters.date(element.ChargebackDate, "DD")
                );

                dataset.data.push({
                  x: i,
                  y: element.PercentageFraudAmount,
                });

                i = i + 1;
              }
            );

            this.chartChargebackPercentage.datasets.push(dataset);
          } else this.showChart = false;
          // #endregion Chart Chargeback Diário : Percentual

          // #region Chart Brand
          if (
            this.infoDashboard.DateTimeBrandDays != null &&
            this.infoDashboard.DateTimeBrandDays.length > 0
          ) {
            this.showChartBrand = true;
            i = 0;
            this.chartChargebackBrand = {
              labels: [],
              datasets: [],
            };

            this.infoDashboard.DateTimeBrandDays.forEach((element) => {
              this.chartChargebackBrand.labels.push(
                this.$options.filters.date(element, "DD/MM")
              );
            });

            this.infoDashboard.ChargebackDashboardBrandDays.forEach(
              (element) => {
                let label = element.Brand.Name;
                let borderColor = this.GetDataBorderColor(element.Brand.Id);
                let backgroundColor = this.GetDataColor(element.Brand.Id);

                let dataset2 = {
                  label: label,
                  borderColor: borderColor,
                  backgroundColor: backgroundColor,
                  data: [],
                };

                element.ChargebackDashboardBrandDay.forEach((element2) => {
                  dataset2.data.push({
                    x: i,
                    y: element2.PercentageFraudAmount,
                  });
                  i = i + 1;
                });

                this.chartChargebackBrand.datasets.push(dataset2);
              }
            );
          } else this.showChartBrand = false;
          // #endregion Chart Brand

          // #region Chart por MCC
          if (
            this.infoDashboard.DateTimeMccDays != null &&
            this.infoDashboard.DateTimeMccDays.length > 0
          ) {
            this.showChartMcc = true;
            var j = 0;

            this.chartChargebackMCC = {
              labels: [],
              datasets: [],
            };

            this.infoDashboard.DateTimeMccDays.forEach((element) => {
              this.chartChargebackMCC.labels.push(
                this.$options.filters.date(element, "DD/MM")
              );
            });

            this.infoDashboard.ChargebackDashboardMccDays.forEach((element) => {
              let label = element.Mcc.EstablishmentID;
              let borderColor = this.GetDataMccBorderColor(element.Mcc.Id);
              let backgroundColor = this.GetDataMccColor(element.Mcc.Id);

              let datasetMcc = {
                label: label,
                borderColor: borderColor,
                backgroundColor: backgroundColor,
                data: [],
              };

              element.ChargebackDashboardMccDay.forEach((element2) => {
                datasetMcc.data.push({
                  x: j,
                  y: element2.PercentageFraudAmount,
                });
                j = j + 1;
              });

              this.chartChargebackMCC.datasets.push(datasetMcc);
            });
          } else this.showChartMcc = false;
          // #endregion Chart por MCC
        })
        .catch((error) => {
          this.$makeToast(
            undefined,
            "danger",
            "Erro ao carregar o Dashboard",
            error
          );
        })
        .finally(() => (this.loading = false));
    },
    HandleScroll: function () {
      if (
        document.body.scrollTop > 400 ||
        document.documentElement.scrollTop > 400
      ) {
        this.showBtnScroll = true;
      } else {
        this.showBtnScroll = false;
      }
    },
    ScrollToTop: function () {
      window.scrollTo(0, 0);
    },
    OpenBrandTransaction: function (e, idBrand) {
      e.preventDefault();
      this.$router.push({
        name: "chargeback-dashboard-brand",
        params: { idBrand: idBrand },
        query: {
          referenceDate: this.filter.paymentDate,
          idMcc: this.filter.idMcc,
        },
      });
    },
    ListMCC: function (idMcc) {
      this.$store
        .dispatch("ListMCC")
        .then((response) => {
          this.mccs = response;
        })
        .catch((error) => {
          this.$makeToast(
            undefined,
            "danger",
            "Erro carregar a lista de MCCs",
            error
          );
        });
    },
  },
};
</script>

<style scoped>
.padding-right-item {
  padding-right: 10px;
}
.padding-left-item {
  padding-left: 35px;
}
.icon-gold {
  color: #edd05c;
}
.icon-silver {
  color: #9ea5b5;
}
.icon-bronze {
  color: #e09848;
}
.button-arrow {
  padding: 0px;
}
</style>
<style>
.tooltip-inner {
  font-size: 10pt;
}
.iconList {
  font-size: 40px;
  margin-top: 15%;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/chargebackDashboard.vue